import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl, imageUrl } from "../../../Baseurl";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Trash2 } from "react-feather";

const AllDocument = () => {
  const { listing_id } = useParams();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await axios.get(`${baseurl}getDocumentsByListingProductId/${listing_id}`);
        console.log("API Response:", response);

        if (response.data.message === "Documents retrieved successfully.") {
          setDocuments(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
        Swal.fire({
          icon: "error",
          title: "Failed to load documents",
          text: "There was an error while fetching the documents.",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, [listing_id]);

  const handleDelete = async (documentId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${baseurl}deleteDocumentById/${documentId}`);
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Document Deleted",
            text: "The document has been successfully deleted.",
          });
          setDocuments(documents.filter((doc) => doc.id !== documentId));
        }
      } catch (error) {
        console.error("Error deleting document:", error);
        Swal.fire({
          icon: "error",
          title: "Delete Failed",
          text: "There was an error while deleting the document. Please try again.",
        });
      }
    }
  };

  return (
    <div className="container ">
      {/* <h3 className="text-center mb-3">Uploaded Documents</h3> */}

      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div className="spinner-border text-danger" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : documents.length > 0 ? (
        <table className="table table-bordered text-center">
          <thead className="table-dark">
            <tr>
              {/* <th className="table-dark">ID</th> */}
              {/* <th className="table-dark">Listing ID</th> */}
              <th className="table-dark">Product ID</th>
              <th className="table-dark">Document Name</th>
              <th className="table-dark">Download</th>
              <th className="table-dark">Action</th>
            </tr>
          </thead>
          <tbody>
            {documents.map((doc) => {
              const fileUrl = `${imageUrl}documents/${doc.document_name}`;

              return (
                <tr key={doc.id}>
                  {/* <td>{doc.id}</td> */}
                  {/* <td>{doc.listing_id}</td> */}
                  <td>{doc.listing_product_id}</td>
                  <td>{doc.document_name}</td>
                  <td>
                    <a href={fileUrl} target="_blank" download className="btn btn-primary btn-sm">
                      Download
                    </a>
                  </td>
                  <td>
                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(doc.id)}>
                      <Trash2 />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <p className="text-center">No documents found.</p>
      )}
    </div>
  );
};

export default AllDocument;
